/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CalendarDayDto } from './calendarDayDto';
import { CalendarServiceTypeDto } from './calendarServiceTypeDto';


export interface CalendarDto { 
    maxOrdersPerDay?: number;
    maxOrdersPerServiceType?: number;
    maxOrdersPerShop?: number;
    days?: Array<CalendarDayDto> | null;
    availableServiceTypes?: Array<CalendarServiceTypeDto> | null;
}

